import apiRequest from './apiRequest';

export type BrowseSearchSuggestions = {
  autoCompleteTitles: string;
  autoCompleteShort: string;
  ngramTitles: string;
};

export default async function getBrowseSearchSuggestions(searchTerm: string) {
  const { data, error } = await apiRequest<any>(
    'mogen-orchestration',
    `/browseSearchSuggestions?searchTerm=${encodeURIComponent(searchTerm)}`,
    {
      method: 'GET',
    },
  );
  return { data, error };
}
